// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.animationSlideDownAndUp {
    animation: slideDownAndUp 0.5s cubic-bezier(0.12, 0.42, 0.65, 0.95);
}

@keyframes slideDownAndUp {
    0% {
        transform: translateY(0)
    }
    50% {
        transform: translateY(300px)
    }
    100% {
        transform: translateY(0)
    }
}
.footer .MuiBadge-badge{
    transform: scale(1) translate(5%, -30%);
    background-color: #d11010;
    color: white;
}
.messageSeparator{
    width: 520px;
    overflow-x: visible;
}
.messageSeparator::before{
    height: 2px;
}
.messageSeparator::after{
    height: 2px;
}
.risposta {
    max-width: 400px;
}
.richiesta {
    max-width: 450px;
}



`, "",{"version":3,"sources":["webpack://./src/UI/Footer.css"],"names":[],"mappings":";AACA;IACI,mEAAmE;AACvE;;AAEA;IACI;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;AACJ;AACA;IACI,uCAAuC;IACvC,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB","sourcesContent":["\n.animationSlideDownAndUp {\n    animation: slideDownAndUp 0.5s cubic-bezier(0.12, 0.42, 0.65, 0.95);\n}\n\n@keyframes slideDownAndUp {\n    0% {\n        transform: translateY(0)\n    }\n    50% {\n        transform: translateY(300px)\n    }\n    100% {\n        transform: translateY(0)\n    }\n}\n.footer .MuiBadge-badge{\n    transform: scale(1) translate(5%, -30%);\n    background-color: #d11010;\n    color: white;\n}\n.messageSeparator{\n    width: 520px;\n    overflow-x: visible;\n}\n.messageSeparator::before{\n    height: 2px;\n}\n.messageSeparator::after{\n    height: 2px;\n}\n.risposta {\n    max-width: 400px;\n}\n.richiesta {\n    max-width: 450px;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
